@if (isLoading) {
  <div class="loading-overlay">
    <app-skeleton-loading />
  </div>
}
<div class="layout-template" [class.sidebar-open]="isSidebarOpen">
  <app-navbar />
  <div class="layout-template__body">
    <app-sidebar class="layout-template__sidebar" />
    <div class="layout-template__content">
      <router-outlet />
    </div>
  </div>
</div>
